import * as React from 'react';

export const MindlyCircleLogo52x52 = () => (
  <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="mindly_avatar">
      <g id="Ellipse 318">
        <circle cx="26" cy="26" r="26" fill="#0288D1" />
        <circle cx="26" cy="26" r="25.5" stroke="#212121" stroke-opacity="0.1" />
      </g>
      <path
        id="Union"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.8268 25.4037C36.2234 25.4037 38.9999 22.6271 38.9999 19.2305C38.9999 15.8339 36.2234 13.0573 32.8268 13.0573C29.4303 13.0573 26.6537 15.8339 26.6537 19.2305L26.6537 25.4037H32.8268ZM32.8267 38.9999C29.4302 38.9999 26.6536 36.2232 26.6536 32.8266C26.6536 29.43 29.4302 26.6534 32.8267 26.6534C36.2233 26.6534 38.9998 29.43 38.9998 32.8266L38.9998 38.9999H32.8267ZM25.3469 19.2306C25.3469 15.834 22.5703 13.0573 19.1737 13.0573L13.0007 13.0573L13.0007 19.2306C13.0007 22.6272 15.7773 25.4038 19.1737 25.4038C22.5703 25.4038 25.3469 22.6272 25.3469 19.2306ZM19.1731 26.6534C15.7766 26.6534 13 29.4301 13 32.8267C13 36.2234 15.7766 39 19.1731 39C22.5697 39 25.3463 36.2234 25.3463 32.8267L25.3462 26.6534H19.1731Z"
        fill="white"
      />
    </g>
  </svg>
);

export const MindlyCircleLogo35x35 = () => (
  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="mindly_avatar">
      <g id="Ellipse 318">
        <circle cx="17.5" cy="17.5" r="17.5" fill="#0288D1" />
        <circle cx="17.5" cy="17.5" r="17.15" stroke="#212121" stroke-opacity="0.1" />
      </g>
      <path
        id="Union"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.0912 17.0982C24.3157 17.0982 26.1249 15.2889 26.1249 13.0644C26.1249 10.8399 24.3157 9.03064 22.0912 9.03064C19.8667 9.03064 18.0574 10.8399 18.0574 13.0644L18.0574 17.0982H22.0912ZM22.0911 26.1249C19.8666 26.1249 18.0573 24.3156 18.0573 22.0911C18.0573 19.8666 19.8666 18.0573 22.0911 18.0573C24.3156 18.0573 26.1248 19.8666 26.1248 22.0911L26.1248 26.1249H22.0911ZM17.0991 13.0645C17.0991 10.84 15.2898 9.03068 13.0653 9.03068L9.03174 9.03068L9.03174 13.0645C9.03174 15.289 10.841 17.0983 13.0653 17.0983C15.2898 17.0983 17.0991 15.289 17.0991 13.0645ZM13.0649 18.0573C10.8404 18.0573 9.03107 19.8666 9.03107 22.0911C9.03107 24.3156 10.8404 26.125 13.0649 26.125C15.2894 26.125 17.0987 24.3156 17.0987 22.0911L17.0986 18.0573H13.0649Z"
        fill="white"
      />
    </g>
  </svg>
);
